import { makeStyles, useTheme } from '@material-ui/core';
import hashicorpIbmFullWhite from '../../assets/logos/hashicorp-ibm-full-white.svg';
import hashicorpIbmFullBlack from '../../assets/logos/hashicorp-ibm-full-black.svg';
import { useMemo } from 'react';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 48,
    maxWidth: '180px',
  },
});

/**
 * Calculate relative luminance of a color
 * Used to determine if we need black or white logo
 */
function getLuminance(color: string): number {
  // Handle hex colors
  if (color.startsWith('#')) {
    const hex = color.slice(1);
    const rgb = parseInt(hex, 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  }

  // Handle rgb()/rgba()
  const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
  if (match) {
    const [, r, g, b] = match.map(Number);
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  }

  // Fallback: assume dark
  return 0;
}

/**
 * Full HashiCorp + IBM Company lockup logo
 * Automatically selects black or white variant based on background luminance
 */
const LogoFull = () => {
  const classes = useStyles();
  const theme = useTheme();

  const logo = useMemo(() => {
    const navBg =
      theme.palette.navigation?.background || theme.palette.background.default;
    const luminance = getLuminance(navBg);

    // If background is light (luminance > 0.5), use black logo
    // If background is dark (luminance <= 0.5), use white logo
    return luminance > 0.5 ? hashicorpIbmFullBlack : hashicorpIbmFullWhite;
  }, [theme]);

  return (
    <img src={logo} alt="HashiCorp, an IBM Company" className={classes.img} />
  );
};

export default LogoFull;
